import { gql } from '@apollo/client/core';

export const getCertificationStatus = gql`
  query getCertificationStatus($input: CertificationInput!) {
    hotelX {
      certifications(data: $input) {
        adviseMessage {
          code
          description
          code
        }
        totalCount
        edges {
          node {
            code
            createdAt
            updatedAt
            certificationData {
              code
              certified
              validations {
                status
                scenario
                error
              }
            }
          }
        }
      }
    }
  }
`;
